module.exports = __webpack_public_path__ + "img/sjSKU.c54466e2.png";